// @ts-nocheck

const PANEL_PADDING = 10; // pixel

export { PANEL_PADDING };
